import { MdOutlineClear } from 'react-icons/md';
import { Button } from '@ds';
import { CountryStatePairFilter } from '@features/components/CountryStatePairFilter';
import { UseFiltersType } from '@/hooks/useFilters';
import { HospitalListFilters } from '@/api/apis/facilities';

type HospitalFiltersProps = UseFiltersType<HospitalListFilters>;

export const HospitalFilters = ({ filters, hasFilters, updateFilters, clearFilters }: HospitalFiltersProps) => {
  return (
    <div className="flex gap-7 items-center">
      <CountryStatePairFilter filters={filters} updateFilters={updateFilters} />
      {hasFilters && (
        <Button startContent={<MdOutlineClear size={18} />} size="sm" variant="light" onClick={clearFilters}>
          Clear all
        </Button>
      )}
    </div>
  );
};
